import React from "react";

const TutoRapide = () => {
  return (
    <div className="tuto-rapide-card">
      <div className="tuto-rapide-header">
        <span className="tuto-rapide-eyebrow">Tuto rapide</span>
        <h3 className="tuto-rapide-title">À découvrir</h3>
      </div>
      <div className="tuto-rapide-frame">
        <iframe
          src="https://view.genially.com/67bc6f01adfe1a4aa74077c1"
          title="Tuto rapide"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default TutoRapide;
